import { createSlice } from '@reduxjs/toolkit';

const initialState = { isTyping: false, gptResponse: {} };

const gptSlice = createSlice({
  name: 'gptSummary',
  initialState,
  reducers: {
    toogleIsTyping: (state, action) => {
      state.isTyping = action.payload;
    },
    setGptResponse: (state, action) => {
      state.gptResponse = {
        ...state.gptResponse,
        [action.payload.documentId]: action.payload.value
      };
    },
    resetSummary: (state, action) => {
      state.gptResponse = '';
    }
  }
});

export const { toogleIsTyping, setGptResponse, resetSummary } =
  gptSlice.actions;
export default gptSlice.reducer;
